// @ts-check

import { actionTypes as liveMapPageActionsTypes } from '../../actions/LiveMap/liveMapPageActions';
import { Map } from 'immutable';


/** 
 * @typedef {import("../../actions/LiveMap/liveMapPageTypes").LocationTooltipState} LocationTooltipState
 * @typedef {import("../../actions/LiveMap/liveMapPageTypes").MapSearchResultsState} MapSearchResultsState
 * 
 * 
 */





let defaultState = {
  loading: false,


  mapSettings: null,
  activeMapSetting: null,
  
  /** @type {MapSearchResultsState} */
  searchResultsState: 'HIDDEN',
  searchResults: null,


  /** @type {LocationTooltipState} */
  locationTooltipState: 'HIDDEN',

  locationDetails: null,
  
  fullStatus: null,

};

/**
 * @param {{ type: string; payload: any; }} action
 */
export default function (state = Map(defaultState), action) {

  // console.log('REDUCER => LIVEMAP_PAGE');




  switch (action.type) {


    case liveMapPageActionsTypes.LIVEMAP_PAGE__FETCHSETTINGS_STARTED:
      // console.log('REDUCER => LIVEMAP_PAGE__FETCHSETTINGS_STARTED ===> ');
      return state
        .set('loading', true);

    case liveMapPageActionsTypes.LIVEMAP_PAGE__FETCHSETTINGS_FINISHED:
      // console.log('REDUCER => LIVEMAP_PAGE__FETCHSETTINGS_FINISHED ===> ');

      // let allMapsSettings = action.payload;
      // let defaultMapSetting = findDefaultSettingInServerData(allMapsSettings);
      
      let activeMapSetting = action.payload;

      return state
        .set('loading', false)
        .set('activeMapSetting', activeMapSetting);
        // .set('mapSettings', action.payload);



    case liveMapPageActionsTypes.LIVEMAP_PAGE__TOOLTIP_LOCATION_HIDE:
      // console.log('REDUCER => LIVEMAP_PAGE__TOOLTIP_LOCATION_HIDE ===> ');
      return state
        .set('locationTooltipState', 'HIDDEN');

    case liveMapPageActionsTypes.LIVEMAP_PAGE__TOOLTIP_LOCATION_FETCHDATA_STARTED:
      // console.log('REDUCER => LIVEMAP_PAGE__TOOLTIP_LOCATION_FETCHDATA_STARTED ===> ');
      return state
        .set('locationTooltipState', 'LOADING');

    case liveMapPageActionsTypes.LIVEMAP_PAGE__TOOLTIP_LOCATION_FETCHDATA_FINISHED:
      console.log('REDUCER => LIVEMAP_PAGE__TOOLTIP_LOCATION_FETCHDATA_FINISHED ===> ', action.payload);
      return state
        .set('locationTooltipState', 'VISIBLE')
        .set('locationDetails', action.payload);


    case liveMapPageActionsTypes.LIVEMAP_PAGE__FULLSTATUS_FETCHDATA_FINISHED:
      console.log('REDUCER => LIVEMAP_PAGE__FULLSTATUS_FETCHDATA_FINISHED ===> ', action.payload);
      return state
        .set('fullStatus', action.payload);



    case liveMapPageActionsTypes.LIVEMAP_PAGE__SEARCH_FETCHDATA_STARTED:
      console.log('REDUCER => LIVEMAP_PAGE__SEARCH_FETCHDATA_STARTED ===> ');
      return state
        .set('searchResultsState', 'LOADING');
        //.set('searchResults', null);

    case liveMapPageActionsTypes.LIVEMAP_PAGE__SEARCH_FETCHDATA_FINISHED:
      console.log('REDUCER => LIVEMAP_PAGE__SEARCH_FETCHDATA_FINISHED ===> ', action.payload);
      return state
        .set('searchResultsState', 'VISIBLE')
        .set('searchResults', action.payload);

    case liveMapPageActionsTypes.LIVEMAP_PAGE__SEARCHRESULTS_HIDE:
      console.log('REDUCER => LIVEMAP_PAGE__SEARCHRESULTS_HIDE ===> ');
      return state
        .set('searchResultsState', 'HIDDEN');




    default:
      return state;
  }
}






////////////////////////////////////
// Helper functions
// 



/**
 * @param {any[]} sMapSettings
 */
function findDefaultSettingInServerData(sMapSettings) {

  if (!sMapSettings) {
    return null;
  }

  if (sMapSettings.length === 0) {
    return null;
  }

  let enabledOnly = sMapSettings.filter(s => s.enabled);
  if (enabledOnly.length === 0) {
    return null;
  }

  let defaultSetting = enabledOnly.find(s => s.default);
  if (defaultSetting) {
    return defaultSetting;
  }

  let s = enabledOnly[0];
  return s;
}


